export default "__VITE_ASSET__DonCOLoL__"